import { Injectable } from "@angular/core";
import { PackingService } from "../../services";
import { StringToJsonConversion } from "../../JSON-conversions";
import { NotificationService } from "../notification/notification.service";
import { FileExporter } from "../../util";
import { ProductDetail } from "../../types";

@Injectable({
    providedIn: 'root',
})
export class PackingListFileExporter {

    constructor(
        private packingService: PackingService,
        private stringToJsonConversion: StringToJsonConversion,
        private fileExporter: FileExporter,
        private notificationService: NotificationService,
    ) { }


    async exportExcelFile(packingListId: number) {
        try {

            let date = this.getCurrentDate()
            let fileName = `Packing List ${date}`

            let packingData = await this.getPackingById(packingListId.toString())

            if (packingData) {
                await this.fileExporter.exportExcelFile(packingData, fileName)
            } else {
                this.notificationService.Error("Packing list is empty")
            }



        } catch (error) {
            console.log(error);
            this.notificationService.Error("Error exporting packing list")
        }
    }

    getCurrentDate() {
        let date = new Date()
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    }

    async getPackingById(id: string) {

        let dataArray: any[] = []
        try {

            let packingResponse = await this.packingService.getPacking(id).toPromise()
            let packingData = packingResponse?.data

            let packingListBreackdowns: any[] = packingData.packing_list_breakdowns
            let packingListContents: any[] = packingData.packing_sticker_content


            // Merge based on packReference
            const mergedArray = packingListBreackdowns.map(breakdown => {
                const sticker = packingListContents.find(sticker => sticker.packReference_sticker === breakdown.packReference);
                return { ...breakdown, ...sticker };
            });

            for (let item of mergedArray) {
                let productDetail : ProductDetail= item.productDetails
                let pdfVariables = {
                    packreference: item.packReference_sticker,
                    customer: item.customer.customerName,
                    poNo: item.poNumber,
                    jobNo: item.jobNumber,
                    description: item.description,
                    productCode: productDetail?.productCode ?? "",
                    batchNo: productDetail?.batchNo ?? "",
                    packingQuantity: item.packingQuantity,
                    date: item.date,
                }
                dataArray.push(pdfVariables)
            }

            return dataArray
        } catch (error) {
            console.log(error);
            return null
        }
    }
}